import { db } from '@/js/external-js/config/main_config';

export interface SOC2ControlMatrixEntry {
  id: string;
  controlID: string;
  suggestedAssurance: string[];
}

const getMatrixCollectionRef = (tenancyId: string) =>
  db
    .collection('compliance')
    .doc('soc2ControlsMatrix')
    .collection('matrix');

export const listSOC2ControlMatrix = async (tenancyId: string): Promise<SOC2ControlMatrixEntry[]> => {
  if (!tenancyId) return [];

  try {
    const snapshot = await getMatrixCollectionRef(tenancyId).get();
    if (snapshot.empty) {
      return [];
    }

    return snapshot.docs.map(docSnap => {
      const data = docSnap.data() || {};
      const controlID = typeof data.controlID === 'string' && data.controlID.trim().length > 0
        ? data.controlID.trim()
        : docSnap.id;

      const suggestedAssurance: string[] = Array.isArray(data.suggestedAssurance)
        ? data.suggestedAssurance.filter((item: unknown): item is string => typeof item === 'string' && item.trim().length > 0)
        : [];

      return {
        id: docSnap.id,
        controlID,
        suggestedAssurance,
      };
    });
  } catch (error) {
    console.error('[SOC2ControlMatrixService] Failed to load matrix:', error);
    throw error;
  }
};

export const getSOC2ControlById = async (tenancyId: string, controlId: string): Promise<SOC2ControlMatrixEntry | null> => {
  if (!tenancyId || !controlId) return null;

  try {
    const docSnap = await getMatrixCollectionRef(tenancyId).doc(controlId).get();
    if (!docSnap.exists) {
      return null;
    }

    const data = docSnap.data() || {};
    const controlID = typeof data.controlID === 'string' && data.controlID.trim().length > 0
      ? data.controlID.trim()
      : docSnap.id;

    const suggestedAssurance: string[] = Array.isArray(data.suggestedAssurance)
      ? data.suggestedAssurance.filter((item: unknown): item is string => typeof item === 'string' && item.trim().length > 0)
      : [];

    return {
      id: docSnap.id,
      controlID,
      suggestedAssurance,
    };
  } catch (error) {
    console.error(`[SOC2ControlMatrixService] Failed to fetch control ${controlId}:`, error);
    throw error;
  }
};

export default {
  listSOC2ControlMatrix,
  getSOC2ControlById,
};
